export function formatBytes(n: number): string {
	if (!Number.isFinite(n)) return ''
	const units = ['B', 'KB', 'MB', 'GB']
	let i = 0,
		v = n
	while (v >= 1024 && i < units.length - 1) {
		v /= 1024
		i++
	}
	return `${v.toFixed(v >= 10 || i === 0 ? 0 : 1)}${units[i]}`
}
